import { Customer } from "src/common/models/customer"
import { CustomerForm } from "../../CustomerForm"
import { useDispatch, useSelector } from "react-redux"
import { getCustomerByIdApi } from "../../state/action"
import { useEffect } from "react"
import { useParams } from "react-router"
import { RootState } from "src/state/reducer"
import { GET_CUSTOMER_BY_ID_API } from "../../state/actionTypes"
import { serviceLoading } from "src/common/apiLoader/state/selection"

interface ReduxProps {
    currentCustomer?: Customer
    isLoadingCustomer: boolean
}

export const CustomerData = () => {
    const dispatch = useDispatch()
    const { id: customerId } = useParams<{ id: string }>();

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        currentCustomer: state.customer.currentCustomer,
        isLoadingCustomer: serviceLoading(state, [GET_CUSTOMER_BY_ID_API]),
    }))

    useEffect(() => {
        if (customerId && !reduxProps.currentCustomer) {
            dispatch(getCustomerByIdApi(Number(customerId)))
        }
    }, [])

    return (
        reduxProps.isLoadingCustomer
            ? <>Loading</>
            : <CustomerForm
                onFinish={function (customer: Partial<Customer>): void {
                    throw new Error("Function not implemented.")
                }}
                onCancel={function (): void {
                    throw new Error("Function not implemented.")
                }}
                initialValues={reduxProps.currentCustomer}
                readOnly
            />
    )
}
